// Story 8.10 (ADO-2019), Q7: the "HHT" marker on a cart line that came from an accepted handheld
// terminal order, substitutes included (there is no separate substitute marker). The part to
// show is `min(hhtQuantity, quantity)`: the server caps `hht_quantity` on every quantity
// change, and an optimistic line can still carry the part from before the edit.
import type { BasketLine } from '../api/basket.client';

/** "HHT" when the whole quantity came from HHT, "N of M from HHT" when part did, else null. */
export function hhtCartLabel(line: Pick<BasketLine, 'quantity' | 'hhtQuantity'>): string | null {
  const part = Math.min(line.hhtQuantity ?? 0, line.quantity);
  if (part <= 0) return null;
  return part >= line.quantity ? 'HHT' : `${part} of ${line.quantity} from HHT`;
}
